// Every entity that is not an exchange is stored as a "wallet"; its
// category says what it really is. Same values as WALLET_CATEGORIES in the
// backend. "plural" is the short name used for the Entities tabs.
export const ENTITY_CATEGORIES = [
  { value: "wallet", label: "Wallet", plural: "Wallets", color: "blue" },
  {
    value: "custody",
    label: "Custody & finance",
    plural: "Custody",
    color: "yellow",
  },
  {
    value: "infrastructure",
    label: "Infrastructure",
    plural: "Infrastructure",
    color: "gray",
  },
  {
    value: "data",
    label: "Data & compliance",
    plural: "Data",
    color: "gray",
  },
  { value: "project", label: "Project / dApp", plural: "Projects", color: "gray" },
  { value: "other", label: "Other", plural: "Other", color: "gray" },
];

export const categoryOf = (wallet) => wallet?.category ?? "wallet";

export const categoryLabel = (value) =>
  ENTITY_CATEGORIES.find((category) => category.value === value)?.label ??
  "Wallet";
